module.exports = __webpack_public_path__ + "static/media/quiz-05.7f705b49.jpg";